import { tap } from 'rxjs/operators';
import { forOwn, isPlainObject, isArray } from 'lodash-es';
import dayjs from 'dayjs';

import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * RegExp to test a string for an ISO 8601 Date spec
 */
const ISO_8601 =
  /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i;

/**
 * RegExp to test a string for a full ISO 8601 Date
 */
const ISO_8601_FULL =
  /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;

export const dateInterceptor: HttpInterceptorFn =
  (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

    return next(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          //isoDateFix(event.body);
        }
      })
    );
  };

function isoDateFix(object: any) {
  forOwn(object, (value, key, obj) => {
    if (isPlainObject(value) || isArray(value)) {
      isoDateFix(value);
    } else if (value && typeof value === 'string') {
      if (ISO_8601.test(value) && dayjs(value).isValid()) {
        console.log('dateInterceptor', value);
        obj[key] = dayjs(value).toDate();
      }
    }
  });
}


/*import { tap } from 'rxjs/operators';
import { forOwn, isPlainObject, isArray } from 'lodash-es';
import dayjs  from 'dayjs';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class dateInterceptor implements HttpInterceptor {*/
  /**
   * RegExp to test a string for an ISO 8601 Date spec
   */
  /*private ISO_8601 = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i;
  */
  /**
   * RegExp to test a string for a full ISO 8601 Date
   */
  /*private ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request.clone()).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.body) {
          this.ISODateFix(event.body);
        }
      })
    );
  }

  public ISODateFix(object: any) {
    forOwn(object, (value, key, obj) => {
      if (isPlainObject(value)) {
        this.ISODateFix(value);
      } else if (isArray(value)) {
        this.ISODateFix(value);
      } else if (value && typeof value === 'string') {
        // Try parsing with dayjs ISO
        if (dayjs(value).isValid() && this.ISO_8601.test(value)) {
          obj[key] = dayjs(value).toDate();
        }
      }
    });
  }
}
*/
/*
import { tap } from 'rxjs/operators';
import { forOwn, isPlainObject, isArray } from 'lodash-es';

import * as moment from 'moment-mini-ts';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

//Convert date to string
@Injectable()
export class dateInterceptor implements HttpInterceptor {
  /**
    * RegExp to test a string for a ISO 8601 Date spec
    *  YYYY
    *  YYYY-MM
    *  YYYY-MM-DD
    *  YYYY-MM-DDThh:mmTZD
    *  YYYY-MM-DDThh:mm:ssTZD
    *  YYYY-MM-DDThh:mm:ss.sTZD
    * @see: https://www.w3.org/TR/NOTE-datetime
    * @type {RegExp}
    *
  private ISO_8601 = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i

  /**
    * RegExp to test a string for a full ISO 8601 Date
    * Does not do any sort of date validation, only checks if the string is according to the ISO 8601 spec.
    *  YYYY-MM-DDThh:mm:ss
    *  YYYY-MM-DDThh:mm:ssTZD
    *  YYYY-MM-DDThh:mm:ss.sTZD
    * @see: https://www.w3.org/TR/NOTE-datetime
    * @type {RegExp}
    *
  private ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Handle request
    return next.handle(request.clone()).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (event) {
          if (event.body) {
            this.ISODateFix(event.body);
          }
        }
      }
    }));
  }

  ISODateFix(object: any) {
    forOwn(object, (value, key, object) => {
      if (isPlainObject(value)) {
        this.ISODateFix(value);
      } else if (isArray(value)) {
        this.ISODateFix(value);
      }
      else {
        if (value) {
          let _date = moment(value, moment.ISO_8601, true);
          if (_date.isValid() && this.ISO_8601.test(value)) {
            object[key] = _date.toDate();
          }
        }
      }
    })
  }
}
*/
